export const PRIORITY_TYPES = [
  { 1: '1 - RED ALERT', color: 'maroon' },
  { 2: '2 - High', color: 'purple' },
  { 3: '3 - Medium', color: 'saddlebrown' },
  { 4: '4 - Long Wait', color: 'olive' },
  { 5: '5 - Regular', color: 'gray' },
]

export const DEPARTMENT_TYPES = {
  'Feels Factory': 'Feels Factory',
  MIT: 'MIT',
  Other: 'Other',
}

export const REPORT_TYPES = {
  INCORRECT_CONTENT: 'Incorrect Content/Media',
  ADD_ARTIST_TO_ORG: 'Add Artist To My Label',
  MISSING_CONTENT: 'Missing Content',
  DISASSOCIATE_CONTENT: 'Disassociate Content',
  OTHER: 'Other',
  NEEDS_SYNC: 'Needs Sync',
}

export const STATUS_TYPES = {
  in_progress: 'In progress',
  resolved: 'Resolved',
  no_action: 'No action',
}

export const TABLE_HEADERS = [
  'Status',
  'Object',
  'Report Type',
  'Link to Feels Item',
  'Artist',
  'Youtube Item Link',
  'Issue Notes',
  'Priority',
  'Reported by Email',
  'Organization',
  'Organization Role',
  'Department',
  'Assigned to',
  'Previous Page',
  'Artist Displayed Name',
  'New Organization Name',
  'All Rights Carry Forward',
  'Label Start Date',
  'Previous Label Name',
  'Previous Label Start Date',
  'Previous Label End Date',
  'Editor Notes',
  'Number of Reports',
  'Date Reported',
  'Date Modified',
  'Report Id',
]
